function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.15 5.85v24.3H5.85V5.85h24.3zm-11.056 2.7H11.25v18.334h3.973V19.55H19.4c1.324 0 1.528 1.425 1.63 2.445.137 1.643.375 3.276.712 4.89h4.38a10.629 10.629 0 01-1.02-4.38c-.297-2.477-.305-4.28-3.12-4.658l-.241-.028a4.416 4.416 0 003.769-4.482c0-3.77-3.259-4.787-6.417-4.787zm-.61 3.055c1.731 0 2.75.713 2.75 2.342 0 1.63-1.019 2.445-2.75 2.546h-3.26v-4.888h3.26z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgRegionalTrain = function SvgRegionalTrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegionalTrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/regionalTrain.fc5a76e6.svg";
export { ForwardRef as ReactComponent };